import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, get, post, put } from "helpers/api_helper"
import { EXPORT_OPTIONS_LIST, EXPORT_OPTIONS_DELETE } from "helpers/url_helper"

export const getExportOptionsList = createAsyncThunk(
  EXPORT_OPTIONS_LIST,
  async payload => {
    const response = await post(EXPORT_OPTIONS_LIST, payload)
    return response
  }
)
export const deleteExportOption = createAsyncThunk(
  EXPORT_OPTIONS_DELETE,
  async payload => {
    console.log({ payload })
    const response = await del(`${EXPORT_OPTIONS_DELETE}/${payload}`)
    return response
  }
)
